<template>
  <v-toolbar-items>
    <v-btn
      text
      style="text-transform: none; color: darkslategrey"
      v-if="!spinner"
    >
      <v-icon
        color="green"
        medium
      >
        check_circle</v-icon>
      <span>Synced</span>
    </v-btn>
    <v-btn
      v-else
      text
      color="grey"
    >
      <span class="loader-btn">
        <v-icon light>cached</v-icon>
      </span>
    </v-btn>
  </v-toolbar-items>
</template>

<script>
  export default {
    name: 'header-component-sync',
    data () {
      return {
      }
    },
    computed: {
      spinner () {
        return this.$store.getters.getSpinner
      },
      notifications () {
        return this.$store.getters.getNotifications
      }
    }
  }
</script>
<style>
  .loader-btn {
    animation: spinner 1s infinite;
    display: flex;
  }
  @-moz-keyframes spinner {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spinner {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes spinner {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes spinner {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
